import React from "react";
import DigitzsImg from "assets/img/digitzs-final-logo.png";
import { Button } from "reactstrap";

// Define the Manheim component
const DigitzsMerchantLogin = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://digitzs.transactiongateway.com/merchants/login.php?cookie_check=1&referrer=L21lcmNoYW50cy9pbmRleC5waHA_&qed=8c1116f4f94cffe72c735939374ddc62203fb68b2f8fae8fb52475074c07fa1a",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div className="mb-3" target="_blank">
			<img src={DigitzsImg} alt="Digitzs" className="miniLogo" />
			<Button onClick={openInNewTab}>Digitzs Merchant Login</Button>
		</div>
	);
};

export default DigitzsMerchantLogin;
